import React, { useState, memo } from 'react'
import PropTypes from 'prop-types'
import { ChevronIcon } from '@sainsburys-tech/bolt-icons'
import { KLARNA_PROVIDED } from '../../../../helpers/FinanceProviderConstants'

import * as Styled from './FinanceAccordion.styles'

const FinanceAccordion = ({
  title,
  children,
  availableProviders,
  showThirdPartyPayments = false,
  PAYPAL_IFC_MESSAGING = false,
  KLARNA_MESSAGING = false,
  KLARNA_CREDITPLAN = false,
  PAYPAL_MESSAGING = false
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const showKlarnaLogo =
    showThirdPartyPayments &&
    KLARNA_MESSAGING &&
    (KLARNA_CREDITPLAN ? availableProviders.includes(KLARNA_PROVIDED) : true)
  const showPayPalLogo = showThirdPartyPayments && (PAYPAL_MESSAGING || PAYPAL_IFC_MESSAGING)

  const toggleAccordion = () => {
    setIsOpen(prevState => !prevState)
  }

  return (
    <Styled.AccordionContainer data-test='finance-accordion'>
      <Styled.AccordionHeader
        data-test='finance-accordion-header'
        onClick={toggleAccordion}
        aria-expanded={isOpen}
        aria-controls='finance-accordion-content'
      >
        <Styled.TitleAndLogosContainer>
          <Styled.AccordionTitleChevronContainer>
            <Styled.AccordionTitle data-test='finance-accordion-title'>{title}</Styled.AccordionTitle>
            <ChevronIcon dir={isOpen ? 'up' : 'down'} width='24px' height='24px' />
          </Styled.AccordionTitleChevronContainer>
          {!isOpen && (
            <Styled.IconsContainer>
              {showKlarnaLogo && (
                <Styled.LabelImage
                  src='//media.4rgos.it/i/Argos/Klarna_Logo'
                  width='44'
                  height='40'
                  data-test='klarna-label-image'
                  alt='klarna-image'
                />
              )}
              {showPayPalLogo && (
                <Styled.LabelImage
                  src='//media.4rgos.it/i/Argos/PayPal_Logo'
                  width='44'
                  height='40'
                  data-test='paypal-label-image'
                  alt='paypal-image'
                />
              )}
            </Styled.IconsContainer>
          )}
        </Styled.TitleAndLogosContainer>
      </Styled.AccordionHeader>
      <Styled.AccordionContent className={isOpen ? 'open' : ''}>
        {React.Children.map(children, child => (
          <Styled.AccordionContentWrapper>{child}</Styled.AccordionContentWrapper>
        ))}

        <Styled.Terms>18+, T&Cs apply, Credit subject to status.</Styled.Terms>
      </Styled.AccordionContent>
    </Styled.AccordionContainer>
  )
}

FinanceAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  availableProviders: PropTypes.arrayOf(PropTypes.string),
  showThirdPartyPayments: PropTypes.bool,
  PAYPAL_IFC_MESSAGING: PropTypes.bool,
  KLARNA_MESSAGING: PropTypes.bool,
  KLARNA_CREDITPLAN: PropTypes.bool,
  PAYPAL_MESSAGING: PropTypes.bool
}

export default memo(FinanceAccordion)
